import { SCREEN, SIDE_NAV_ICON } from '../../Common';
import { BreadcrumbItem } from '../../component/molecules/BreadcrumbsList';

export const getBreadcrumbInfoAtFirstLevel = (pathnames: string[]): BreadcrumbItem => {
  if (pathnames.includes(SCREEN.LINKED_DATA_RESULT.URL)) {
    return {
      icon: SIDE_NAV_ICON.LINKED_DATA_RESULT,
      text: '登録連携情報一覧',
      to: SCREEN.LINKED_DATA_RESULT.URL,
    };
  }
  if (pathnames.includes(SCREEN.CUSTOMER_INFO_LIST.URL)) {
    return {
      icon: SIDE_NAV_ICON.CUSTOMER_INFO_LIST,
      text: '顧客一覧',
      to: SCREEN.CUSTOMER_INFO_LIST.URL,
    };
  }
  return {
    icon: SIDE_NAV_ICON.SEARCH,
    text: '商談一覧',
    to: SCREEN.NEGOTIATION_SEARCH_RESULT.URL,
  };
};
